/* Cité Érotik — language switcher dropdown Web Component */
(function () {
  'use strict';

  class LocalizationForm extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-localization-toggle]');
      this.list = this.querySelector('[data-localization-list]');
      if (!this.toggle || !this.list) return;

      this.toggle.addEventListener('click', (e) => {
        e.stopPropagation();
        this.setOpen(this.list.classList.contains('hidden'));
      });
      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) this.setOpen(false);
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.setOpen(false); });
    }

    setOpen(open) {
      this.list.classList.toggle('hidden', !open);
      this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }
  if (!customElements.get('localization-form')) customElements.define('localization-form', LocalizationForm);
})();
